import PropTypes from 'prop-types'

const EngagementIcon = ({ title }: any) => (
  <svg width={28} height={33} viewBox="0 0 28 33">
    <title>{title}</title>
    <g strokeWidth={3} fill="none" fillRule="evenodd" strokeLinecap="square">
      <path d="M7 15.15v4M23.17 13.12l-11.503-1.97v-7a2.333 2.333 0 00-2.334-2.334h0A2.333 2.333 0 007 4.149v11H5a2.667 2.667 0 00-2.667 2.667v3.86c0 1.817.618 3.58 1.754 4.999L7 31.149h17.333l2.075-13.486a4 4 0 00-3.238-4.544zM13.667 19.15v6.666M19 19.15v6.666" />
    </g>
  </svg>
)

EngagementIcon.displayName = 'EngagementIcon'

EngagementIcon.propTypes = {
  title: PropTypes.string
}

EngagementIcon.defaultProps = {
  title: 'Engagement'
}

export default EngagementIcon
